import React from 'react'
// components
import RelatedRisk from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/RiskContainer/components/RelatedRisk'
import RiskTemplateAPI from 'containers/Risks/RiskTemplate/Edit/layers/API'
import RiskViewProvider from 'containers/Risks/RiskView/Risk/layers'
// context
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
// types
import { IRisk } from 'types/graphql'

interface Props {
  risk: IRisk
  isScheduled: boolean
  parentRiskId: string
  riskTemplateId: string
}

const RiskViewRelatedRiskContainer: React.FC<Props> = ({ risk, isScheduled, parentRiskId, riskTemplateId }) => {
  const { riskView } = React.useContext(RiskRegisterContext)

  const form = `RELATED_RISK_${parentRiskId}_${risk.id}_FORM`

  return (
    <RiskTemplateAPI riskView={riskView} riskTemplateId={riskTemplateId}>
      <RiskViewProvider risk={risk} form={form} isScheduled={isScheduled}>
        <RelatedRisk form={form} risk={risk} />
      </RiskViewProvider>
    </RiskTemplateAPI>
  )
}

export default RiskViewRelatedRiskContainer
